/** Shared primitives & design tokens for the ENTERPRISE360 admin surface.
 * Extracted from Enterprise360Panel.jsx so the panel and its sub-components share
 * one source of truth for inputs, eyebrows and the band colour map. */
import React from "react";

export const BASE = process.env.REACT_APP_BACKEND_URL;

export const Eyebrow = ({ children }) => (
  <div className="text-[11px] font-semibold tracking-[0.18em] uppercase text-[var(--e360-primary)] mb-2">{children}</div>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="block text-[11px] tracking-[0.14em] uppercase text-zinc-500 mb-1">{label}</span>
    {children}
  </label>
);

export const sel = "ek-select w-full border border-zinc-300 rounded-md px-3 py-2 text-[15px] bg-white";
export const inp = "ek-input w-full border border-zinc-300 rounded-md px-3 py-2 text-[15px]";

export const bandColor = (band) => ({
  Emerging: "bg-rose-100 text-rose-700", Developing: "bg-amber-100 text-amber-700",
  Established: "bg-emerald-100 text-emerald-700", Advanced: "bg-emerald-200 text-emerald-800",
}[band] || "bg-zinc-100 text-zinc-600");

export const dispColor = (d) => ({
  "Retain as-is": "bg-emerald-100 text-emerald-700", "Reconfigure / Upgrade": "bg-amber-100 text-amber-700",
  "Replace": "bg-rose-100 text-rose-700", "Retire": "bg-zinc-200 text-zinc-600",
}[d] || "bg-zinc-100 text-zinc-600");

export const EMPTY_SYS = { name: "", category: "", business_fit: 3, technical_health: 3, serves: "" };
